export const STEP = {
  ACCOUNT_DETAILS: 1,
  ACCOUNT_AUTH: 2,
  PERSONAL_DETAILS: 3,
};

export const ADDITIONAL_STEP = {
  ARTIST_INFO: 4,
};
